import { Component } from '@angular/core';

@Component({
  selector: 'privacy-policy',
  templateUrl: './privacyPage.component.html',
})
export class PrivacyPolicyPageComponent {}
